import React from "react"
import PropTypes from "prop-types"

const ConfigsHeader = ({
  dirtyCount,
  hayInvalidos,
  isSaving,
  isSaved,
  onDescartar,
  onGuardar,
}) => {
  const puedeGuardar = dirtyCount > 0 && !hayInvalidos && !isSaving

  let claseGuardar = "cfg-btn cfg-btn-save"
  if (isSaving) claseGuardar += " is-saving"
  else if (isSaved) claseGuardar += " is-saved"
  else if (puedeGuardar) claseGuardar += " is-active"

  let textoGuardar = "Guardar cambios"
  if (isSaving) textoGuardar = "Guardando…"
  else if (isSaved) textoGuardar = "✓ Guardado"

  return (
    <div className="cfg-head cfg-anim">
      <div className="mt-3">
        <div className="cfg-eyebrow d-none">
          Pedidos
          <span className="sep">›</span>
          <span className="cur">Configuraciones</span>
        </div>
        <h1>Horarios y comisiones</h1>
        <p>
          Define la ventana en la que cada cliente puede levantar pedidos y la
          comisión que se cobra por unidad.
        </p>
      </div>

      <div className="cfg-head-actions">
        {hayInvalidos && (
          <span className="cfg-chip cfg-chip-error">
            Hay horarios sin completar o invertidos
          </span>
        )}
        {dirtyCount > 0 && !isSaved && (
          <>
            <span className="cfg-chip cfg-chip-warn">
              {dirtyCount}
              {dirtyCount === 1 ? " cambio sin guardar" : " cambios sin guardar"}
            </span>
            <button
              type="button"
              className="cfg-btn cfg-btn-ghost"
              onClick={onDescartar}
            >
              Descartar
            </button>
          </>
        )}
        <button
          type="button"
          className={claseGuardar}
          disabled={!puedeGuardar}
          onClick={onGuardar}
        >
          {textoGuardar}
        </button>
      </div>
    </div>
  )
}

ConfigsHeader.propTypes = {
  dirtyCount: PropTypes.number,
  hayInvalidos: PropTypes.bool,
  isSaving: PropTypes.bool,
  isSaved: PropTypes.bool,
  onDescartar: PropTypes.func,
  onGuardar: PropTypes.func,
}

export default ConfigsHeader
